import { enviroment } from "../../enviroment";

// Layout classes of the status-line badge family (NavWriteBackPendingBadge,
// UploadFailedBadge, ProductPendingBadge): the ONE place that reads flag
// REACT_APP_LOGO_STATUS_BADGE_WRAP_ENABLED.
//
// Today (and with the flag off) the badge is a `whitespace-nowrap`
// inline-flex child of the status cell - a flex-col StrucCol with no
// overflow clip - so a text wider than the cell runs into the next column:
// the logo list's status column is 1/12 of the row (~112 px at the page's
// 90 rem cap, ~99 px on a 1280 px laptop) and "Sendes til leverandøren"
// (da/no) measures 148.5 px in Inter 600 12 px with the dot and gap, so it
// ran into the actions column's "View designs" button (20/10).
//
// With the flag on, a call site that passes `wrap` (the list row's and the
// popup's status cell - nowhere else) gets the wrapping set instead:
// whitespace-normal lets the text break at spaces inside the cell,
// break-words breaks a single word that is still too wide ("leverandøren"
// alone is 76.6 px, so that is for narrower cells only), leading-tight keeps
// two lines compact, max-w-full keeps the span inside the cell, and
// items-start + the dot's mt-[0.45em] (line-height 1.25 x 12 px = 15 px;
// (15 - 4) / 2 = 5.5 px) keep the dot centred on the FIRST line instead of
// floating between the two. Everything else (text-xs, font-semibold, the
// tone, the caller's className) stays as today.
export const STATUS_BADGE_LAYOUT = "inline-flex items-center gap-2 whitespace-nowrap";
export const STATUS_BADGE_LAYOUT_WRAP =
  "inline-flex items-start gap-2 whitespace-normal break-words leading-tight max-w-full";
export const STATUS_BADGE_DOT = "shrink-0";
export const STATUS_BADGE_DOT_WRAP = "shrink-0 mt-[0.45em]";

function wraps(wrap: boolean | undefined): boolean {
  return wrap === true && enviroment.logoStatusBadgeWrapEnabled;
}

export function statusBadgeLayoutClass(wrap?: boolean): string {
  return wraps(wrap) ? STATUS_BADGE_LAYOUT_WRAP : STATUS_BADGE_LAYOUT;
}

export function statusBadgeDotClass(wrap?: boolean): string {
  return wraps(wrap) ? STATUS_BADGE_DOT_WRAP : STATUS_BADGE_DOT;
}
